module.exports = __webpack_public_path__ + "static/media/second_winner.38e77baa.jpg";